<template>
  <div class="schedule-qrcode">
    <div class="header">
      <div class="header-cont">
        <div class="title">
          <el-radio-group size="mini" v-model="qrcodeType">
            <el-radio-button label="1">静态</el-radio-button>
            <el-radio-button label="2">动态</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="main">
      <keep-alive>
        <component v-if="qrcodeComponent"
                   :is="qrcodeComponent"
                   :row-data="rowData"
                   :sign-info="signInfo"
                   @updateQrcode="$emit('updateQrcode')"></component>
      </keep-alive>
    </div>
    <div class="footer">
      <el-link v-if="selectType === qrcodeType" type="primary" disabled>已启用</el-link>
      <el-tooltip v-else content="同一时间只能启用一种">
        <el-button type="primary" :loading="isSetup" @click="setupQrcodeType">{{isSetup ? '设置中...' : '启用'}}</el-button>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import StaticQrcode from './qrcode/StaticQrcode'
import DynamicQrcode from './qrcode/DynamicQrcode'
export default {
  name: 'QrcodeComponent',
  components: {
    StaticQrcode,
    DynamicQrcode
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    signInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      qrcodeType: '1',
      selectType: '',
      isSetup: false
    }
  },
  created () {
    // 如果行数据中有二维码类型，则使用该类型
    let qrcodeType = this.signInfo.qrcodeType
    if (qrcodeType) {
      this.qrcodeType = qrcodeType
      this.selectType = qrcodeType
    }
  },
  computed: {
    qrcodeComponent: function () {
      switch (this.qrcodeType) {
        case '1':
          return StaticQrcode
        case '2':
          return DynamicQrcode
        default:
          break
      }
    }
  },
  methods: {
    setupQrcodeType () {
      let qrcodeType = this.qrcodeType
      this.isSetup = true
      this.$ajax({
        url: '/workspace/manager/teaching/schedule/query/clazz/setupSignQrcodeType',
        method: 'post',
        data: this.$qs.stringify({
          signId: this.signInfo.id,
          qrcodeType: qrcodeType
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.selectType = qrcodeType
              // 更新行数据中的二维码类型
              this.$set(this.signInfo, 'qrcodeType', qrcodeType)
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.isSetup = false
      })
    }
  },
  updated () {
    this.$emit('updateQrcode')
  }
}
</script>

<style lang="scss">
  .schedule-qrcode {
    & > .header {
      padding-bottom: 12px;
      border-bottom: 1px solid #ebeef5;
      margin-bottom: 12px;
      & > .header-cont {
        position: relative;
        & > .title {
          text-align: center;
          .el-radio-group {
            .el-radio-button__inner {
              padding: 5px 10px;
            }
          }
        }
      }
    }
    & > .main {
      position: relative;
    }
    & > .footer {
      margin: 12px -12px -12px -12px;
      border-top: 1px solid #ebeef5;
      text-align: center;
      .el-button {
        display: block;
        width: 100%;
        padding: 8px 12px;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        border-color: transparent;
      }
      .el-link {
        font-size: 12px;
        padding: 8px 12px;
      }
    }
  }
</style>
